<template>
  <section class="workflow-list" :class="{ loading, ready: !loading }">
    <header class="filters">
      <flex-grid align-items="center" width="100%"></flex-grid>
      <template v-if="filterMode !== FILTER_MODE_ADVANCED">
        <flex-grid align-items="center" width="100%">
          <flex-grid-item grow="1">
            <text-input
              :label="$t('dj-流程') + 'ID'"
              type="search"
              name="wid"
              :value="searchBody.wid"
              @input="onFilterChange($event)"
            />
          </flex-grid-item>
          <flex-grid-item grow="1">
            <text-input
              :label="$t('dj-模板') + 'ID'"
              type="search"
              name="templateId"
              :value="searchBody.templateId"
              @input="onFilterChange"
            />
          </flex-grid-item>
          <flex-grid-item grow="1">
            <text-input
              :label="$t('dj-模板名称')"
              type="search"
              name="templateName"
              :value="searchBody.templateName"
              @input="onFilterChange"
            />
          </flex-grid-item>
          <flex-grid-item v-if="notIsv" grow="1">
            <text-input
              :label="$t('dj-租户') + 'ID'"
              type="search"
              name="tenantId"
              :value="searchBody.tenantId"
              @input="onFilterChange"
            />
          </flex-grid-item>
          <flex-grid-item grow="1" width="160px">
            <select-input
              data-cy="status-filter"
              :label="$t('dj-状态')"
              name="status"
              :options="statusList"
              :value="status"
              @change="onStatusChange"
            />
          </flex-grid-item>
          <flex-grid-item grow="1" width="400px">
            <a-range-picker
              :default-value="defaultRange"
              :show-time="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="[$t('dj-开始时间'), $t('dj-结束时间')]"
              @change="onTimeChange"
              @ok="onTimeOk"
            />
          </flex-grid-item>
          <flex-grid-item>
            <a-button type="primary" round @click.native="handleSearch()">
              {{ $t("dj-查询") }}</a-button
            >
          </flex-grid-item>
        </flex-grid>
      </template>
    </header>
    <error-message :error="error" />
    <!-- <workflow-grid
            :workflows="formattedResults"
            :loading="loading"
            v-if="!error"
        /> -->
    <a-table
      :columns="columns"
      :data-source="workflows"
      :pagination="paginationOpt"
      :loading="loading"
      row-key="id"
    >
      <a slot="rid" slot-scope="runid, item" @click="toRunDetail(item)"
        >{{ runid }}
      </a>
      <div slot="status" slot-scope="status">{{ statusLabel(status) }}</div>
      <div slot="endTime" slot-scope="endTime">
        {{ endTime ? endTime : "-" }}
      </div>
    </a-table>
  </section>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { ErrorMessage } from "@/components";
import FlexGrid from "@/components/flex-grid.vue";
import FlexGridItem from "@/components/flex-grid-item.vue";
import SelectInput from "@/components/select-input.vue";
import TextInput from "@/components/text-input.vue";
import api from "@/api";
import i18n from "@/assets/i18n/translate-message";
import { getFormattedResults, getMinStartDate } from "./helpers";
import {
  FILTER_MODE_ADVANCED,
  GETSTATUS_LIST,
  GETSTATUSLABLE,
} from "./constants";
export default {
  name: "WorkflowList",
  components: {
    "error-message": ErrorMessage,
    "flex-grid": FlexGrid,
    "flex-grid-item": FlexGridItem,
    "select-input": SelectInput,
    "text-input": TextInput,
  },
  props: [
    "clusterName",
    "dateFormat",
    "domain",
    "fetchWorkflowListUrl",
    "filterBy",
    "filterMode",
    "filterModeButtonEnabled",
    "filterModeButtonLabel",
    "queryString",
    "state",
    "timeFormat",
    "timezone",
    "workflowId",
    "workflowName",
  ],
  data() {
    return {
      abortController: undefined,
      loading: false,
      results: [],
      error: undefined,
      npt: undefined,
      nptAlt: undefined,
      statusList: GETSTATUS_LIST(i18n),
      maxRetentionDays: undefined,
      FILTER_MODE_ADVANCED,
      status: i18n.t("dj-全部"),
      defaultRange: [
        moment(moment().day(-30), "YYYY-MM-DD HH:mm:ss"),
        moment(moment(), "YYYY-MM-DD HH:mm:ss"),
      ],
      searchBody: {
        wid: "", // 类型：String  可有字段  备注：workflowId
        rid: "", // 备注：runId  暂不需要
        templateId: "", // 类型：String  可有字段  备注：模板id
        templateName: "", // 模版名称
        tenantId: this.tenantId,
        status: "", // 类型：String  可有字段  备注：状态
        startTime: moment().day(-30).format("YYYY-MM-DD HH:mm:ss"), // 类型：String  可有字段  备注：开始时间
        endTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 类型：String  可有字段  备注：结束时间
        pageNo: 1, // 类型：Number  必有字段  备注：当前页码，默认1
        pageSize: 5, // 类型：Number  必有字段  备注：每页数据量
      },
      workflows: [],
      columns: [
        {
          title: `${i18n.t("dj-流程")} ID`,
          dataIndex: "wid",
          key: "wid",
        },
        {
          title: "RUN ID",
          dataIndex: "rid",
          key: "rid",
          scopedSlots: { customRender: "rid" },
        },
        {
          title: `${i18n.t("dj-租户")} ID`,
          dataIndex: "tenantId",
          key: "tenantId",
          width: 130,
          ellipsis: true,
        },
        {
          title: `${i18n.t("dj-模板")} ID`,
          dataIndex: "templateId",
          key: "templateId",
        },
        {
          title: i18n.t("dj-模板名称"),
          dataIndex: "templateName",
          key: "templateName",
        },
        {
          title: i18n.t("dj-状态"),
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
          width: 100,
        },
        {
          title: i18n.t("dj-开始时间"),
          dataIndex: "startTime",
          key: "startTime",
          width: 140,
        },
        {
          title: i18n.t("dj-结束时间"),
          dataIndex: "endTime",
          key: "endTime",
          scopedSlots: { customRender: "endTime" },
          width: 140,
        },
      ],
      paginationOpt: {
        current: 1,
        defaultCurrent: 1, // 默认当前页数
        defaultPageSize: 5, // 默认当前页显示数据的大小
        total: 0, // 总数，必须先有
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "30"],
        showTotal: (total) => `共 ${total} 条`, // 显示总数
        onShowSizeChange: (current, pageSize) => {
          this.paginationOpt.defaultCurrent = 1;
          this.paginationOpt.current = 1;
          this.paginationOpt.defaultPageSize = pageSize;
          this.searchBody.pageNo = 1;
          this.searchBody.pageSize = pageSize;
          this.fetchWorkflowList();
        },
        // 改变每页数量时更新显示
        onChange: (current, size) => {
          this.paginationOpt.defaultCurrent = current;
          this.paginationOpt.current = current;
          this.paginationOpt.defaultPageSize = size;
          this.searchBody.pageNo = current;
          this.searchBody.pageSize = size;
          this.fetchWorkflowList();
        }, // 点击页码事件
      },
    };
  },
  async created() {
    await this.fetchDomain();
    this.fetchWorkflowList();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.now = new Date();
    }, 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    ...mapGetters("auth", ["userInfo"]),
    formattedResults() {
      const { clusterName, dateFormat, results, timeFormat, timezone } = this;

      return getFormattedResults({
        clusterName,
        dateFormat,
        results,
        timeFormat,
        timezone,
      });
    },
    minStartDate() {
      return this.getMinStartDate();
    },
    notIsv() {
      const userId = this.userInfo ? this.userInfo.userId : "";
      return (userId ?? "").includes("digiwin.com");
    },
    tenantId() {
      // 需要监听此变量变化，变化了直接请求接口
      const tenantId = this.userInfo ? this.userInfo?.tenantId ?? "" : "";
      return tenantId;
    },
  },
  methods: {
    clearState() {
      this.error = undefined;
      this.loading = false;
      this.npt = undefined;
      this.nptAlt = undefined;
      this.results = [];
    },
    handleSearch() {
      this.paginationOpt.defaultCurrent = 1;
      this.paginationOpt.current = 1;
      this.searchBody.pageNo = 1;
      this.fetchWorkflowList();
    },
    async fetchDomain() {
      this.loading = true;

      try {
        const res = await api.getDomainInfo();
        const domainInfo = res.data.response;

        this.maxRetentionDays =
          Number(
            domainInfo.configuration.workflowExecutionRetentionPeriodInDays
          ) || 30;
        this.loading = false;
      } catch (error) {
        this.error =
          (error.json && error.json.message) || error.status || error.message;
      } finally {
        this.loading = false;
      }
    },
    async fetchWorkflowList() {
      const pam = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const i in this.searchBody) {
        if (this.searchBody[i]) {
          pam[i] = this.searchBody[i];
        }
      }
      this.loading = true;
      const res = await api.getWorkflows(pam);
      this.loading = false;
      if (res.status === 200 && res.data.response) {
        const { response } = res.data;
        this.paginationOpt.total = response.total;
        this.workflows = response.content;
      } else {
        this.$message.error("查询workflow列表失败！");
        return;
      }

      this.results = [...this.results];
    },
    onFilterChange(event) {
      const target = event.target || event.testTarget; // test hook since Event.target is readOnly and unsettable
      const name = target.getAttribute("name");
      const { value } = target;
      this.searchBody[name] = value;
    },

    statusLabel(val) {
      return GETSTATUSLABLE(val, i18n);
    },
    toRunDetail(item) {
      window.open(`${window.location.href}/${item.wid}/${item.rid}/summary`);
      // this.$router.push(`workflows/${item.wid}/${item.rid}/summary`);
    },
    onTimeChange(value, dateString) {
      console.log("Selected Time: ", value);
      console.log("Formatted Selected Time: ", dateString);
      // eslint-disable-next-line prefer-destructuring
      this.searchBody.startTime = dateString[0];
      // eslint-disable-next-line prefer-destructuring
      this.searchBody.endTime = dateString[1];
    },
    onTimeOk(value) {
      console.log("onOk: ", value);
    },
    getMinStartDate() {
      const { maxRetentionDays, now, statusName } = this;

      return getMinStartDate({
        maxRetentionDays,
        now,
        statusName,
      });
    },
    onStatusChange(val) {
      if (val) {
        this.searchBody.status = val.status === "all" ? "" : val.status;
        this.status = val.label;
      }
    },
  },
  watch: {
    tenantId(newValue) {
      console.log("Computed Value Changed:", newValue);
      this.paginationOpt.defaultCurrent = 1;
      this.paginationOpt.current = 1;
      this.searchBody.pageNo = 1;
      this.fetchWorkflowList();
    },
  },
};
</script>

<style lang="stylus">
@require '../../styles/definitions.styl';

section.workflow-list {
  display: flex;
  flex: auto;
  flex-direction: column;

  &.loading section.results table {
    opacity: 0.7;
  }
}
</style>
<style lang="less" scoped>
::v-deep .ant-calendar-picker {
  width: 400px !important;
  height: 42px;
  display: flex;
  align-items: center;
  .ant-calendar-range-picker-separator {
    vertical-align: unset !important;
    // font-weight: 700 !important;
  }
  .ant-input {
    height: 100% !important;
    border-radius: 0 !important;
  }
  input {
    padding: unset !important;
    margin: 0px !important;
  }
}
</style>
